import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useStore } from "@/store/StoreContext";
import ProductCard from "@/components/ProductCard";
import { Reveal, Eyebrow } from "@/components/Reveal";

export default function Wishlist() {
  const { wishlist } = useStore();
  const [products, setProducts] = useState(null);

  useEffect(() => {
    api.get("/products").then((r) => {
      setProducts(r.data.filter((p) => wishlist.includes(p.slug)));
    }).catch(() => setProducts([]));
  }, [wishlist]);

  return (
    <div className="pt-16" data-testid="wishlist-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-24 pb-24 sm:pb-32">
        <Reveal><Eyebrow>Saved Pieces</Eyebrow></Reveal>
        <Reveal delay={0.1}>
          <h1 className="font-display font-extrabold uppercase tracking-tight text-5xl sm:text-7xl mt-4 leading-[0.9]">
            Wish<span className="text-outline">list</span>
          </h1>
        </Reveal>

        <div className="mt-14">
          {products === null ? (
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
              {Array.from({ length: 4 }).map((_, i) => <div key={i} className="aspect-[3/4] bg-noir-card animate-pulse" />)}
            </div>
          ) : products.length === 0 ? (
            <div className="py-20 text-center" data-testid="wishlist-empty">
              <p className="font-display uppercase tracking-[0.15em] text-cream/60 mb-2">Nothing saved yet</p>
              <p className="text-sm text-cream/40 mb-8">Tap the heart on any piece to keep it here.</p>
              <Link to="/shop" className="font-mono2 text-[10px] tracking-[0.25em] uppercase border border-gold/60 text-gold px-6 py-3 hover:bg-gold hover:text-noir-bg transition-colors duration-300" data-testid="wishlist-shop-link">
                Shop the Drop
              </Link>
            </div>
          ) : (
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6" data-testid="wishlist-grid">
              {products.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
